import BordPhoto from 'components/NudosComponents/BordPhoto/BordPhoto';
import NudosHoverText from 'components/NudosComponents/NudosHoverText/NudosHoverText';
import { IUserInfo } from 'types/orders';
import './UserWhoCancelledOrder.scss';

/**
 * Componente que muestra la información del usuario que canceló la orden
 * @param userWhoCancelledOrder - Información del usuario que canceló la orden
 */
const UserWhoCancelledOrder = ({ userWhoCancelledOrder }: IUserWhoCancelledOrderProps) => {
  const { firstName, lastName, email, photoProfile } = userWhoCancelledOrder || {};
  const fullName = firstName && lastName ? `${firstName} ${lastName}` : `${email || 'Usuario desconocido'}`;
  const CHARACTER_LIMIT = 20;

  return (
    <div className="userWhoCancelledOrder">
      <div className="userWhoCancelledOrderPhoto">
        <BordPhoto url={photoProfile || ''} size="s24" variant="circle" avatarProps={{ variant: 'circularUser' }} />
      </div>
      <NudosHoverText
        text={fullName}
        charactersLimit={CHARACTER_LIMIT}
        onlyIfTruncated
        customClassName="userWhoCancelledOrderName"
        customTextHoverClassName="userWhoCancelledOrderHover"
      />
    </div>
  );
};

interface IUserWhoCancelledOrderProps {
  userWhoCancelledOrder: IUserInfo | undefined;
}
export default UserWhoCancelledOrder;
